import { render, staticRenderFns } from "./TicketBlockMultipleMatriz.vue?vue&type=template&id=482e4b2f&scoped=true"
import script from "./TicketBlockMultipleMatriz.vue?vue&type=script&lang=js"
export * from "./TicketBlockMultipleMatriz.vue?vue&type=script&lang=js"
import style0 from "./TicketBlockMultipleMatriz.vue?vue&type=style&index=0&id=482e4b2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482e4b2f",
  null
  
)

export default component.exports